import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import customLogger from "../../utils/customLogger.js";

/**
 * Home component that checks authentication status and redirects to appropriate routes
 * If a user is authenticated, they will be redirected to the upload page
 * If not authenticated and auth parameters are in the URL, they will be redirected to the auth page
 * If not authenticated and no auth parameters, they will be redirected to the unauthorized page
 */
const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  
  useEffect(() => {
    // Check if authentication parameters are present in the URL
    const queryParams = new URLSearchParams(location.search);
    const sk = queryParams.get('sk');
    const apiSig = queryParams.get('api_sig');
    
    // For invalid_signature, explicitly clear token and redirect to unauthorized
    if (apiSig === 'invalid_signature') {
      //customLogger.log('INVALID SIGNATURE DETECTED IN HOME - Redirecting to unauthorized');
      localStorage.removeItem('auth_token');
      navigate('/unauthorized', { state: { authFailed: true, reason: 'invalid_signature' } });
      return;
    }
    
    // Clear any previous auth token for other invalid states
    if (!isAuthenticated && (sk === null || apiSig === null)) {
     // customLogger.log('Clearing localStorage - no valid auth parameters');
      localStorage.removeItem('auth_token');
    }
    
    if (isAuthenticated) {
      // If already authenticated, go to the main app
     // customLogger.log('User is authenticated, redirecting to upload page');
      navigate('/upload');
    } else if (sk && apiSig) {
      // If auth parameters are present but not authenticated, go to auth page
      //customLogger.log('Auth parameters present, redirecting to auth page');
      navigate(`/auth${location.search}`);
    } else {
      // If not authenticated and no auth parameters, go to unauthorized page
      //customLogger.log('Not authenticated and no auth parameters, redirecting to unauthorized');
      navigate('/unauthorized');
    }
  }, [isAuthenticated, location.search, navigate]);
  
  // Render a loading state
  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Loading</h2>
        <p>Please wait while we check your authentication status...</p>
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Home;
